import { render, staticRenderFns } from "./emergencyActionPlanDocuFile.vue?vue&type=template&id=56646b5f"
import script from "./emergencyActionPlanDocuFile.vue?vue&type=script&lang=js"
export * from "./emergencyActionPlanDocuFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56646b5f')) {
      api.createRecord('56646b5f', component.options)
    } else {
      api.reload('56646b5f', component.options)
    }
    module.hot.accept("./emergencyActionPlanDocuFile.vue?vue&type=template&id=56646b5f", function () {
      api.rerender('56646b5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/emergencyActionPlanDocuFile.vue"
export default component.exports